export const translateClaimStatus = (claimStatus) => {
    const claimStatusTranslations = {
        OPEN: "Ouverture",
        AWAITING_SERVICE_PROPOSAL: "En attente proposition PEC",
        AWAITING_ASSIGNMENT: "En attente affectation expert / garage",
        AWAITING_INSPECTION: "En attente expertise",
        VEHICLE_INSPECTED: "Véhicule expertisé",
        AWAITING_QUOTATION: "En attente devis",
        AWAITING_QUOTATION_APPROVAL: "En attente validation devis",
        AWAITING_PRELIMINARY_REPORT: "En attente rapport préliminaire",
        AWAITING_CUSTOMER_CALL: "En attente appel client",
        AWAITING_START_OF_REPAIRS: "En attente début des réparations",
        AWAITING_REPAIR: "En attente réparation",
        AWAITING_INVOICE_APPROVAL: "En attente validation facture",
        AWAITING_DISPATCH_OF_RELEASE_FORM: "En attente envois de bon de sortie",
        AWAITING_FINAL_REPORT: "En attente rapport final",
        AWAITING_PAYMENT_APPROVAL: "En attente validation règlement expert / garage",
        ARCHIVED_CLAIM: "Dossier archivé",
        AWAITING_SERVICE_ASSIGNMENT: "En attente affectation expert",
        AWAITING_APPOINTMENT_PROPOSAL: "En attente proposition RDV",
        AWAITING_INVOICE: "En attente facture",
        AWAITING_CLIENT_PAYMENT: "En attente règlement client",
        AWAITING_PICTURES_BEFORE_REPARATION: "En attente photos avant",
        DESIGNATE_PARTIES: "En attente affectation expert / garage",
        AWAITING_PAYMENT: "En attente payment",
        AWAITING_PROVIDER_INVOICE: "En attente facture fournisseur",
        AWAITING_ERECOUR_INSERSION:"En attente chargement plateforme",
        AWAITING_PAYMENT_PROOF:"En attente quittance",
        AWAITING_PICTURE_AND_INVOICE:"En attente photos et facture",
        AWAITING_INSPECTOR_INVOICE:"En attente honoraire expert",
        NO_FOLLOW_UP:"Sans Suite",
        PAYED:"Règlement effectué",
        CLOSED:"Clôturé"
    };

    return claimStatusTranslations[claimStatus] || claimStatus;
};
